import get from 'lodash/get';
export default function updateSearchAlertsActionCreator(userDuck, personalization) {
  return _ref => {
    let {
      bookmarkId,
      enabledFlag,
      targets,
      phone,
      searchName,
      brand = ''
    } = _ref;
    return async (dispatch, getState) => {
      const errorMsg = 'We\'re sorry, but we have encountered an error. Please try again later.';
      // get current saved search object
      if (targets.length > 0 && bookmarkId) {
        try {
          let updateEmailAlerts;
          if (targets[0].toLowerCase() === 'sms' && enabledFlag) {
            // validate phone number in remote cache
            const phoneNumber = phone && phone.replace(/[^0-9]/g, '');
            const currentPhoneNumber = get(getState(), 'user.profile.phone', null);
            const hasValidPhone = await personalization.validatePhone(currentPhoneNumber, phoneNumber);
            // update alerts only if phone number is valid
            if (hasValidPhone.success) {
              dispatch(userDuck.creators.setAlertsError(null));
              updateEmailAlerts = await personalization.updateSearchAlerts({
                bookmarkId,
                enabledFlag,
                targets,
                searchName,
                phone: phoneNumber,
                brand
              });
            } else {
              dispatch(userDuck.creators.setAlertsError('Please enter a valid phone number.'));
            }
          } else {
            updateEmailAlerts = await personalization.updateSearchAlerts({
              bookmarkId,
              enabledFlag,
              targets,
              searchName,
              brand
            });
          }
          if (updateEmailAlerts.responseCode === '200') {
            const bookmarks = get(getState(), 'user.bookmarks.searchBookmarks', {});
            const updatedBookmarks = {
              ...bookmarks
            };
            const targetsCopy = targets[0].toLowerCase() === 'sms' ? 'Text' : 'Email';
            const bookmarkKey = `send${targetsCopy}Alerts`;
            let message;

            // set global alert message
            if (enabledFlag) {
              message = `${targetsCopy} alerts enabled.`;
            } else {
              message = `${targetsCopy} alerts disabled.`;
            }

            // update the alerts values in the bookmark
            updatedBookmarks[bookmarkId] = {
              ...bookmarks[bookmarkId],
              alert: {
                ...bookmarks[bookmarkId].alert,
                [bookmarkKey]: enabledFlag
              }
            };
            dispatch(userDuck.creators.setGlobalAlert({
              key: 'alertsSuccess',
              message
            }));

            // clear errors, close modal, update bookmarks in state
            dispatch(userDuck.creators.setSearchBookmarks(updatedBookmarks));
            dispatch(userDuck.creators.setAlertsModal(false));
            dispatch(userDuck.creators.setAlertsError(null));
          } else {
            dispatch(userDuck.creators.setGlobalAlert({
              key: 'serverFailure',
              message: errorMsg
            }));
          }
        } catch (error) {
          dispatch(userDuck.creators.setGlobalAlert({
            key: 'serverFailure',
            message: errorMsg
          }));
          throw new Error(error);
        }
      }
    };
  };
}